import { Box, Link as JoyLink, Typography, Divider } from '@mui/joy';
import { Link } from 'react-router-dom';
import type { ReactElement } from 'react';
import { Stack } from '@mui/system';

const Footer = (): ReactElement => {
  return (
    <Box component="footer">
      <Divider />
      <Stack direction={'row'} justifyContent={'center'} sx={{ py: 1.5, bgcolor: 'background.surface' }}>
        <Typography level="body-xs">
          <JoyLink component={Link} to="/legal/privacy-policy" textColor="text.tertiary">
            Privacy Policy
          </JoyLink>
        </Typography>
      </Stack>
    </Box>
  );
};

export default Footer;
